let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("IQIOD")).then(() => parcelRequire('hKLwM'));